import "core-js/modules/esnext.global-this.js";
var globals = {
  self: typeof self !== 'undefined' && self,
  window: typeof window !== 'undefined' && window,
  global: typeof global !== 'undefined' && global,
  document: typeof document !== 'undefined' && document,
  process: typeof process === 'object' && process
};
var global_ = globalThis;
var self_ = globals.self || globals.window || globals.global;
var window_ = globals.window || globals.self || globals.global;
var document_ = globals.document || {};
var process_ = globals.process || {};
var console_ = console;
export { self_ as self, window_ as window, global_ as global, document_ as document, process_ as process, console_ as console };